
import { Building, Shield, LineChart } from "lucide-react";
import ProcessCard from "./ProcessCard";

const ExchangeSecurity = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <ProcessCard 
        icon={<Building className="w-6 h-6 text-[#1B2F47]" />} 
        title="Liquidity & Security" 
        content="Strategies must operate on exchanges with ample liquidity and robust security infrastructure." 
      />
      <ProcessCard 
        icon={<Shield className="w-6 h-6 text-[#1B2F47]" />} 
        title="Regulatory Compliance" 
        content="Exchanges must demonstrate compliance with applicable laws and maintain proper licenses." 
      />
      <ProcessCard 
        icon={<LineChart className="w-6 h-6 text-[#1B2F47]" />} 
        title="Reputation & Integration" 
        content="Integration with well-regarded platforms that offer strong track records for uptime and support." 
      />
    </div>
  );
};

export default ExchangeSecurity;
